"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.VersetVerseService = void 0;
const app_consensus_1 = require("@branch-ts/app-consensus");
const cas_1 = require("@branch-ts/cas");
const practice_verse_web_1 = require("@branch-ts/practice-verse-web");
const seqop_consensus_1 = require("@branch-ts/seqop-consensus");
const verse_consensus_1 = require("@branch-ts/verse-consensus");
const web_1 = require("@branch-ts/web");
const web_consensus_1 = require("@branch-ts/web-consensus");
const service_VersetSingular_1 = require("./service.VersetSingular");
const service_VersetBucket_1 = require("./service.VersetBucket");
const service_VersetRequireLogin_1 = require("./service.VersetRequireLogin");
const service_VersetTheme_1 = require("./service.VersetTheme");
const service_VersetWorkerFacility_1 = require("./service.VersetWorkerFacility");
const web_consensus_2 = require("@branch-ts/web-consensus");
const Leaf = __importStar(require("leaf-ts"));
const with_caution_1 = require("with-caution");
let VersetVerseService = (() => {
    let _classDecorators = [(0, app_consensus_1.service)()];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    var VersetVerseService = class {
        static { _classThis = this; }
        constructor() {
            this.me = app_consensus_1.ServiceContext.about(this);
            this.deps = this.me.dependencies({
                NavigationService: web_1.NavigationService,
                VersetBucketService: service_VersetBucket_1.VersetBucketService,
                VersetRequireLoginService: service_VersetRequireLogin_1.VersetRequireLoginService,
                VersetThemeService: service_VersetTheme_1.VersetThemeService,
                VersetWorkerFacilityService: service_VersetWorkerFacility_1.VersetWorkerFacilityService,
                VersetSingularService: service_VersetSingular_1.VersetSingularService,
            });
            this.main = null;
        }
        static {
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
            __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
            VersetVerseService = _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
            __runInitializers(_classThis, _classExtraInitializers);
        }
        get server() {
            return this.deps.VersetRequireLoginService.server;
        }
        async initialize() {
            const agreement = this.deps.VersetRequireLoginService.agreement;
            const singular = this.deps.VersetSingularService.singular;
            const vendor = agreement.vendor;
            const editorKind = agreement.particulars.versetWebapp.verse.editorKind;
            const idpsEditorKind = agreement.particulars.versetWebapp.idps.editorKind;
            const defaultVerseURI = agreement.particulars.versetWebapp.verse.userMainVerseURI;
            this.defaultVerseURI = defaultVerseURI;
            for (const currentEditorKind of new Set([editorKind, idpsEditorKind])) {
                cas_1.EditorEnvironmentRegistryMechanism.editor(currentEditorKind);
                cas_1.EditorEnvironmentRegistryMechanism.register(practice_verse_web_1.VoiceInputMechanism.asPackage(), currentEditorKind);
                (0, cas_1.FatCAS)({
                    editorKind: currentEditorKind,
                    bucketURI: agreement.particulars.versetWebapp.bucketURI,
                });
            }
            this.registerVerseMediator(vendor);
            const { mainVerse, verseGovernor } = (0, practice_verse_web_1.FatVerse)({
                editorKind,
                vendor,
                defaultVerseURI,
                singular,
                trailResource: () => this.deps.VersetWorkerFacilityService.getTrailResource(),
            });
            this.verseGovernor = verseGovernor;
            this.unregisterLogout = web_consensus_2.LogoutMechanism.registerAction("Verset.trails", () => verseGovernor.destroy(), { phase: "cleanup" });
            this.main = mainVerse;
            cas_1.PuriRuneConceptMechanism.packageOf(editorKind).register({
                kind: "ic+ic",
                trigger: (option) => {
                    web_consensus_1.UIMechanism.goto({
                        uri: option.uri,
                    });
                    return true;
                },
            });
            cas_1.PuriRuneConceptMechanism.packageOf(editorKind).register({
                kind: "objective+ic",
                trigger: (option) => {
                    web_consensus_1.UIMechanism.goto({
                        uri: option.uri,
                    });
                    return true;
                },
            });
            cas_1.PuriRuneConceptMechanism.packageOf(editorKind).register({
                kind: "progress+ic",
                trigger: (option) => {
                    web_consensus_1.UIMechanism.goto({
                        uri: option.uri,
                    });
                    return true;
                },
            });
            cas_1.PuriRuneConceptMechanism.packageOf(editorKind).register({
                kind: "spot+ic",
                trigger: (option) => {
                    web_consensus_1.UIMechanism.goto({
                        uri: option.uri,
                    });
                    return true;
                },
            });
            cas_1.PuriRuneConceptMechanism.packageOf(editorKind).register({
                kind: "goal+ic",
                trigger: (option) => {
                    web_consensus_1.UIMechanism.goto({
                        uri: option.uri,
                    });
                    return true;
                },
            });
            web_consensus_1.UIMechanism.registerAppURIResolver({
                resolver: ({ uri }) => {
                    if (typeof uri !== "string" || !uri.startsWith("verse:")) {
                        return false;
                    }
                    singular.governors.visit({
                        beaconURI: uri,
                    });
                    return true;
                },
            });
        }
        destroy() { this.unregisterLogout?.(); this.verseGovernor?.destroy(); }
        registerVerseMediator(vendor) {
            seqop_consensus_1.MediatorRegistryMechanism.register({
                name: `${vendor}+verse+verse`,
                registry: (option) => {
                    const verseInfo = verse_consensus_1.VerseProtocol.VerseURI.parse(option.uri);
                    if (!verseInfo || verseInfo.vendor !== vendor)
                        return null;
                    const provider = new seqop_consensus_1.ReconnectingArbitratorProvider(async () => {
                        const [result, reason, ...errors] = await this.getMyMainVerseProvider();
                        if (reason === "NotFound")
                            throw new seqop_consensus_1.ArbitratorProviderNotFoundError(`Verse is not available: ${option.uri}`, { cause: with_caution_1.CautionUtil.error(reason, ...errors) });
                        if (reason)
                            throw with_caution_1.CautionUtil.error(reason, ...errors);
                        if (!result?.provider)
                            throw new Error("Failed to get verse provider");
                        if (result.verseURI !== option.uri) {
                            // This InnerRPC belongs to another verse; nobody will own it.
                            if ("rpc" in result.provider && result.provider.rpc instanceof Leaf.RPCComposer)
                                result.provider.rpc.unsetConnection();
                            throw new seqop_consensus_1.ArbitratorProviderNotFoundError(`Verse is not available: ${option.uri}; current main verse: ${result.verseURI}`);
                        }
                        return result.provider;
                    }, this.server.authorizedConnection);
                    const mediator = new verse_consensus_1.VerseMediator({ definition: verse_consensus_1.VerseScopeDefinition, arbitrator: provider, uri: option.uri });
                    mediator.shouldCacheLocally = true;
                    return provider.own(mediator);
                },
            });
        }
        async getMyMainVerse() {
            return await this.server.rpcs.VersetUserVerseService.getMyMainVerse({});
        }
        async getMyMainVerseProvider() {
            return await this.server.rpcs.VersetUserVerseService.getMyMainVerseProvider({});
        }
        async createVerse(option) {
            return await this.server.rpcs.VersetUserVerseService.createVerse(option);
        }
        async getVerse(option) {
            return await this.server.rpcs.VersetUserVerseService.getVerse(option);
        }
        async listMyVerses(option = {}) {
            return await this.server.rpcs.VersetUserVerseService.listMyVerses(option);
        }
    };
    return VersetVerseService = _classThis;
})();
exports.VersetVerseService = VersetVerseService;
